<template>
    <v-container align-start>
        <v-form
            class="form-lost"
            v-model="valid"
            ref="form"
            @submit.native.prevent="submit"
        >
            <v-layout>
                <v-flex xs12>
                    <v-text-field
                        v-model="password"
                        solo
                        :label="lang.password_reset_new_placeholder"
                        :disabled="pageLoading"
                        :type="showPwd ? 'text' : 'password'"
                        :rules="rules"
                        :append-icon="
                            showPwd ? 'fas fa-eye' : 'fas fa-eye-slash'
                        "
                        @click:append="showPwd = !showPwd"
                    ></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12>
                    <v-text-field
                        v-model="confrimPassowrd"
                        solo
                        :label="lang.password_reset_confirm_placeholder"
                        :disabled="pageLoading"
                        :type="showCfmPwd ? 'text' : 'password'"
                        :rules="cRules"
                        :append-icon="
                            showCfmPwd ? 'fas fa-eye' : 'fas fa-eye-slash'
                        "
                        @click:append="showCfmPwd = !showCfmPwd"
                    ></v-text-field>
                </v-flex>
            </v-layout>
            <v-btn
                block
                :disabled="!valid"
                class="btn-h48"
                color="primary"
                @click="submit"
            >
                {{ lang.submit_text }}
            </v-btn>
        </v-form>
        <v-dialog v-model="alertVisible">
            <v-card :color="alertType" dark>
                <v-card-text>
                    <v-layout align-center>
                        <span>{{ lang["submit_" + alertType + "_tips"] }}</span>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="white"
                            fab
                            small
                            light
                            @click="alertVisible = false"
                        >
                            <v-icon>fas fa-times</v-icon>
                        </v-btn>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
export default {
    name: "Lost",
    data() {
        return {
            alertVisible: false,
            alertType: "",
            valid: false,
            password: "",
            confrimPassowrd: "",
            showPwd: "",
            showCfmPwd: ""
        };
    },
    computed: {
        ...mapState(["pageLoading", "params"]),
        ...mapGetters(["lang"]),
        isAccountValid() {
            return true;
        },
        isPasswordMatchedRule() {
            let r1 = /(#|&|\s)/g,
                r2 = /^.{6,15}$/;
            return !r1.test(this.password) && r2.test(this.password);
        },
        rules() {
            let tmp = [];
            tmp.push(v => !v && this.lang.empty_password_tips);
            tmp.push(
                () =>
                    this.isPasswordMatchedRule ||
                    this.lang.mismatched_rule_password_tips
            );
            return tmp;
        },
        cRules() {
            let tmp = [];
            tmp.push(v => !v && this.lang.empty_password_tips);
            tmp.push(
                v =>
                    v !== this.password &&
                    this.lang.different_confirm_password_tips
            );
            return tmp;
        }
    },
    watch: {
        alertVisible(val) {
            if (val) {
                return;
            }

            if (this.alertType === "error") {
                this.$router.push({
                    name: "lost",
                    query: Object.assign({}, this.params, {
                        t: Date.now()
                    })
                });
            } else if (this.alertType === "success") {
                this.commitWV({
                    method: "closeWebView"
                });
            }
        }
    },
    methods: {
        ...mapActions(["resetPassword"]),
        ...mapMutations({
            changePageLoading: "CHANGE_PAGE_LOADING",
            changeAuthVerified: "CHANGE_AUTH_VERIFIED",
            commitWV: "COMMIT_WEB_VIEW"
        }),
        submit() {
            if (this.pageLoading) {
                return;
            }
            this.changePageLoading(true);
            this.resetPassword({
                password: this.password
            })
                .then(() => {
                    this.alertVisible = true;
                    this.alertType = "success";
                })
                .catch(() => {
                    this.alertVisible = true;
                    this.alertType = "error";
                });
        }
    }
};
</script>
